import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-fake-user',
  templateUrl: './edit-fake-user.component.html',
  styleUrls: ['./edit-fake-user.component.scss']
})
export class EditFakeUserComponent implements OnInit {
formData: any = {
  name: '',
  email: '',
  mobile: '',
  country_id: '1',
  city_id: '1',
  password: '',
  password_confirmation: '',
  image: null
};

// Declare formData property 
    public arrCountries:any[] = [];
    public country:any[] = [];
  imagePreview: string | ArrayBuffer | null = null;
bookFileName: string | null = null;
    constructor(private router: Router, private apisService: ApisService,
        private route: ActivatedRoute
    ) { }
  
    ngOnInit(): void {
      // this.postCountires();
    const bookId = this.route.snapshot.paramMap.get('id');
  if (bookId) {
    this.fetchBookForEdit(+bookId);
  }
    }
  fetchBookForEdit(id: number): void {
  this.apisService.getFakeUserById(id).subscribe({
    next: (user) => {
      const data = user.data;
      this.formData.name = data.name;
      this.formData.email = data.email;
      this.formData.mobile = data.mobile;
      this.formData.country_id = data.country_id || '';
      this.formData.city_id = data.city_id || '';
      this.formData.password = ''; // Leave blank for security
      this.formData.password_confirmation = ''; // Leave blank
      this.imagePreview = data.image; // Show existing image
    },
    error: (err) => {
      console.error('Error fetching user:', err);
    },
  });
}


    cancel(): void {
      this.router.navigate(['/settings/countries']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    fetchUserForEdit(id: number): void {
  this.apisService.getFakeUserById(id).subscribe({
    next: (res) => {
      const user = res.data;
      this.formData.name = user.name;
      this.formData.email = user.email;
      this.formData.mobile = user.mobile;
      this.formData.country_id = user.country_id;
      this.formData.city_id = user.city_id;
      this.imagePreview = user.image;

      // Do NOT prefill passwords in edit mode for security reasons
      this.formData.password = '';
      this.formData.password_confirmation = '';
    },
    error: (err) => {
      console.error('Error fetching user:', err);
    }
  });
}



onFileSelected(event: Event, type: 'img' | 'book'): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    if (type === 'img') {
      this.formData.image = file;

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }
}



submitForm(): void {
  const formDataToSend = new FormData();

  formDataToSend.append('name', this.formData.name);
  formDataToSend.append('email', this.formData.email);
  formDataToSend.append('mobile', this.formData.mobile);
formDataToSend.append('country_id', String(+this.formData.country_id));
formDataToSend.append('city_id', String(+this.formData.city_id));
  formDataToSend.append('password', this.formData.password);
  formDataToSend.append('password_confirmation', this.formData.password_confirmation);
  formDataToSend.append('image', this.formData.image);


  const id = this.route.snapshot.paramMap.get('id');

  this.apisService.editFakeUser(+id, formDataToSend).subscribe({
    next: (res) => {
      Swal.fire('Success', 'User saved successfully', 'success');
      this.router.navigate(['/fake-user']);
    },
    error: (err) => {
      console.error('Upload error:', err);
      Swal.fire('Error', 'Please fix the errors and try again.', 'error');
    }
  });
}



}
